import React from "react";

const PresentationSectionEN = () => {
  return (
    <section 
      id="presentation" 
      className="section-padding bg-white"
      aria-labelledby="presentation-title"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 
            id="presentation-title"
            className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#1C3A27] mb-4 md:mb-6"
          >
            An authentic haven of peace
          </h2>
          <p className="text-lg md:text-xl text-[#1C3A27]/70 max-w-4xl mx-auto leading-relaxed">
            A former hotel-restaurant carefully restored, our charming gîte offers 130m² of 
            comfortable space in the heart of Norman Switzerland. A place where authenticity meets modern comfort.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-6">
            <div>
              <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#1C3A27] mb-4">
                A story to share
              </h3>
              <p className="text-[#1C3A27]/80 leading-relaxed">
                This former hotel-restaurant has been completely restored with passion and respect for authentic materials. 
                Each space has been designed to offer the perfect balance between traditional Norman charm and 
                contemporary comfort.
              </p>
            </div>
            
            <div>
              <h4 className="font-semibold text-lg text-[#1C3A27] mb-3">Why choose Hearts of Normandy?</h4>
              <ul className="space-y-2 text-[#1C3A27]/80">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-[#1C3A27] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Capacity up to 10 people in 3 comfortable bedrooms
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-[#1C3A27] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  130m² of space with private garden and pétanque court
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-[#1C3A27] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Ideal location in the heart of Clécy, gateway to Norman Switzerland
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-[#1C3A27] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Pets welcome for complete family vacations
                </li>
              </ul>
            </div>
          </div>

          <div className="order-first lg:order-last">
            <div className="aspect-w-16 aspect-h-12 rounded-2xl overflow-hidden shadow-xl">
              <img
                src="/images/Photos-site-coeurd-de-normand-Gîte/SALON1.jpg"
                alt="Main living room of the gîte with authentic decoration"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PresentationSectionEN;